import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.99625 10.0726C10.2886 10.0726 11.3363 9.02492 11.3363 7.73258C11.3363 6.44023 10.2886 5.39258 8.99625 5.39258C7.7039 5.39258 6.65625 6.44023 6.65625 7.73258C6.65625 9.02492 7.7039 10.0726 8.99625 10.0726Z",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.71332 6.3675C4.19082 -0.127498 13.8133 -0.119998 15.2833 6.375C16.1458 10.185 13.7758 13.41 11.6983 15.405C10.1908 16.86 7.80582 16.86 6.29082 15.405C4.22082 13.41 1.85082 10.1775 2.71332 6.3675Z",
		strokeWidth: 1.5
	})]
});
export default SvgLocationIcon;
